// src/pages/CustomerDetails.js
import React from 'react';

export default function CustomerDetails({ user }) {
  // Demo user data if no user prop is provided
  const demoUser = {
    id: 201,
    name: "Alan Turing",
    email: "alan.turing@example.com",
    rideHistory: [
      {
        id: 1,
        date: "2025-01-10T10:00:00",
        car: "Toyota Corolla",
        stayed: "3h 10m",
        parkedBy: "Jerry Jack",
        retrievedBy: "Anna Brave",
        paid: "$12",
        location: "Lot 107",
      },
      {
        id: 2,
        date: "2025-02-01T09:30:00",
        car: "Audi A4",
        stayed: "2h 00m",
        parkedBy: "Zara Lanes",
        retrievedBy: "Jerry Jack",
        paid: "$8",
        location: "Lot 108",
      },
    ]
  };

  const currentUser = user || demoUser;

  return (
    <div style={{ padding: "20px" }}>
      <h2 style={{ marginBottom: "20px", color: "#ba00ba" }}>User Details</h2>
      
      {/* Basic Info */}
      <div style={{
        background: "#fff",
        borderRadius: "8px",
        padding: "20px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        marginBottom: "20px"
      }}>
        <h3 style={{ marginBottom: "10px" }}>{currentUser.name}</h3>
        <p><strong>Email:</strong> {currentUser.email}</p>
      </div>

      {/* Ride History Table */}
      <div style={{
        background: "#fff",
        borderRadius: "8px",
        padding: "20px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
      }}>
        <h3 style={{ marginBottom: "10px" }}>Ride History</h3>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid #eee" }}>
              <th style={{ textAlign: "left", padding: "8px" }}>Date</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Car</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Stayed</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Parked By</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Retrieved By</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Paid</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Location</th>
              <th style={{ textAlign: "left", padding: "8px" }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {currentUser.rideHistory.map((ride, idx) => (
              <tr key={idx} style={{ borderBottom: "1px solid #eee" }}>
                <td style={{ padding: "8px" }}>{new Date(ride.date).toLocaleDateString()}</td>
                <td style={{ padding: "8px" }}>{ride.car}</td>
                <td style={{ padding: "8px" }}>{ride.stayed}</td>
                <td style={{ padding: "8px" }}>{ride.parkedBy}</td>
                <td style={{ padding: "8px" }}>{ride.retrievedBy}</td>
                <td style={{ padding: "8px" }}>{ride.paid}</td>
                <td style={{ padding: "8px" }}>{ride.location}</td>
                <td style={{ padding: "8px" }}>
                  <button
                    onClick={() => alert(`Details for ride ${ride.id}`)}
                    style={{
                      background: "#ba00ba",
                      color: "#fff",
                      border: "none",
                      borderRadius: "5px",
                      padding: "6px 12px",
                      cursor: "pointer"
                    }}
                  >
                    Details
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
